// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__2p41A","footer":"ModalError_footer__2Tt2o"};